(function ($) {
  $(document).ready(function ($) {
    if ($('.b-template').length) {
      // add scrolltrigger plugin
      gsap.registerPlugin(ScrollTrigger);

      // Responsive
      // ---
      ScrollTrigger.matchMedia({
        // large
        '(min-width: 950px)': function () {},
        // all
        all: function () {
          // ScrollTriggers created here aren't associated with a particular media query,
          // so they persist.

          // Circle photo carousel on birding landing page
          // ---
          var $circlecarousel = $('.circle-photo-carousel .owl-carousel');
          $circlecarousel.each(function (index, el) {
            $(el).owlCarousel({
              items: 1,
              loop: true,
              singleItem: true,
              rewind: true,
              nav: false,
              dots: false,
              lazyLoad: true,
              responsive: {
                950: {
                  dots: false,
                },
              },
            });
          });
          // ---
          // END Circle photo carousel on birding landing page
        },
      });
      // ---
      // END Responsive
    }
  });
})(jQuery);
